import api from './interceptor'
import * as config from './../config/config'

export async function get_ListeSite(){
  try{
    const response = await api.get(config.REACT_APP_ENDPOINT_LIST_SITE);
    return response.data;
  } catch (error){
    throw error;
  }
};

export async function updateSite(data) {
  try{
    const response = await api.put(config.REACT_APP_ENDPOINT_UPDATE_SITE + '/' + data['id'], {
      "nom" : data['nom']
    })
    return response.data
  } catch (error) {
    throw(error)
  }
}

export async function createSite(data) {
  try{
    const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_SITE, {
      "id" : data['id'],
      "nom" : data['nom']
    })
    return response.data
  } catch (error) {
    throw (error)
  }
}

export async function deleteSite(data) {
  try{
    const response = await api.delete(config.REACT_APP_ENDPOINT_DELETE_SITE + '/' + data['id'])
    return response.data
  } catch (error) {
    throw(error)
  }
}